import type { SessionState } from './types.ts';

export const LIVE_WAITING_WINDOW_MS = 60_000;

/** Live display only; recorded states and time calculations retain their original event semantics. */
export function liveSessionState(state: SessionState | null, stateSince: number | null, lastEventAt: number | null, now: number): SessionState | null {
  if (state !== 'waiting_input' && state !== 'waiting_permission') return state;
  const began = stateSince ?? lastEventAt;
  return began !== null && began <= now && now - began < LIVE_WAITING_WINDOW_MS ? state : 'idle';
}
